export function tuple<T1, T2>(t1: T1, t2: T2): [T1, T2] {
  return [t1, t2]
}